import React from 'react';
import ClientRow from './ClientRow';
import { BiSortZA, BiSortAZ } from 'react-icons/bi';
import intl from 'components/i18n/ReactIntlWrapper';

const ClientsList = ({ searchResult, input, setInput }) => {

    const handleSortClick = (sort) => {
        setInput({ ...input, orderValue: (input.sortValue == sort ? (input.orderValue == 'desc' ? 'asc' : 'desc') : 'asc'), sortValue: sort, currentPage: 1 });
    }

    return (
        <div className="table-responsive my-2">
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <th role='button' onClick={() => { handleSortClick('Name') }} scope="col">{intl.get('clientsList.table.thead.name')} {input.sortValue == 'Name' ? (input.orderValue == 'desc' ? <BiSortZA></BiSortZA> : <BiSortAZ></BiSortAZ>) : ''}</th>
                        <th role='button' onClick={() => { handleSortClick('TradeName') }} scope="col">{intl.get('clientsList.table.thead.tradeName')} {input.sortValue == 'TradeName' ? (input.orderValue == 'desc' ? <BiSortZA></BiSortZA> : <BiSortAZ></BiSortAZ>) : ''}</th>
                        <th scope="col" className='text-center'>{intl.get('roleList.table.thead.actions')}</th>
                    </tr>
                </thead>
                {
                    searchResult?.clients?.length < 1  && input.queryTerm !== null ?
                    <tbody className='aling-center mb-0'>
                        <tr style={{cursor: "default"}}>
                            <td colSpan={6} className=' mb-0'>{intl.get('clientsList.notFound')}</td>
                        </tr>
                    </tbody> :
                    <tbody>
                        {
                            searchResult?.clients?.length >= 1 && searchResult.clients.map((c,i) => (
                                <ClientRow
                                key={c.id}
                                id={c.id}
                                name={c.name}
                                tradeName={c.tradeName}
                                className={i%2>0?'':'odd'}
                                />
                            ))
                        }
                    </tbody>
                }
            </table>
        </div>
    )
}

export default ClientsList;
